import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/config";
import { stagger, fadeUp } from "@/components/Reveal";

export default function CategoryGrid({ limit }) {
  const list = limit ? CATEGORIES.slice(0, limit) : CATEGORIES;
  return (
    <motion.div
      variants={stagger}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      {list.map((c) => (
        <motion.article
          key={c.slug}
          id={c.slug}
          variants={fadeUp}
          whileHover={{ y: -6 }}
          data-testid={`category-card-${c.slug}`}
          className={`group relative overflow-hidden rounded-3xl border border-forest/20 ${c.tone} scroll-mt-28`}
        >
          <div className="h-44 overflow-hidden">
            <img
              src={c.image}
              alt={c.name}
              className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
            />
          </div>
          <div className="p-6">
            <div className="flex items-start justify-between gap-3">
              <h3 className="font-display text-xl text-forest leading-tight">{c.name}</h3>
              <span className="shrink-0 grid place-items-center h-9 w-9 rounded-full bg-forest text-butter transition-transform duration-300 group-hover:rotate-45">
                <ArrowUpRight className="h-4 w-4" />
              </span>
            </div>
            <p className="text-sm text-forest/70 mt-2 leading-relaxed">{c.desc}</p>
            <div className="flex flex-wrap gap-1.5 mt-4">
              {c.items.slice(0, 4).map((it) => (
                <span key={it} className="text-[11px] font-medium bg-white/70 text-forest/80 rounded-full px-2.5 py-1 border border-forest/10">
                  {it}
                </span>
              ))}
            </div>
          </div>
        </motion.article>
      ))}
    </motion.div>
  );
}
